import React from 'react';
import configureDeps from '@bridebook/web/lib/configure-deps';

const { createContext, useContext } = React;

export const ServicesContext = createContext(configureDeps());

export const useServices = () => useContext(ServicesContext);
